import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";
import { Helmet } from "react-helmet";
import MiddleHeader from "./ui/headers/middleHeader";
import Searchbar from "./includes/Searchbar";
import Footer from "./ui/footer/footer";
import TopNavbar from "./ui/countdown/topNavbar/topNavbar";
import Searchfield from "./ui/searchfield/Searchfield";

function BlogDetail() {
  const { slug } = useParams();
  const [article, setArticle] = useState(null);

  useEffect(() => {
    window.scrollTo(0, 0);

    const fetchArticle = async () => {
      try {
        const response = await axios.get(`/blog/${slug}`);
        setArticle(response.data);
        console.log(response.data);
      } catch (error) {
        console.error("Error fetching blog article:", error);
      }
    };

    fetchArticle();
  }, [slug]);

  if (!article) {
    return <p>Loading...</p>;
  }

  return (
    <><Helmet>
            <title>{article?.title}</title>
            <meta name="description" content={article?.excerpt || article?.title} />
            <meta property="og:title" content={article?.title} />
            <meta
              property="og:description"
              content={article?.excerpt || article?.title}
            />
            <meta property="og:image" content={article?.cover_image} />
            <meta
              property="og:url"
              content={`https://www.bestpreispyro.de/blog/${slug}`}
            />
            <link
              rel="canonical"
              href={`https://www.bestpreispyro.de/blog/${slug}`}
            />
          </Helmet><div className="page-wrapper">
    <header className="header">
      <TopNavbar />
      <MiddleHeader />
      <Searchbar />
      <Searchfield />
    </header>

    <main className="main">
      <div className="page-header">
        <div className="container">
          <h1
            className="page-title mb-0 text-5xl font-bold"
            style={{ marginTop: "2rem", marginBottom: "2rem" }}
          >
            {article.title}
          </h1>
        </div>
      </div>

      <div className="page-content mb-12" style={{ marginTop: "2rem" }}>
        <div className="container pb-10 mb-2">
          <div className="main-content post-single-content">
            <div className="post post-grid post-single">
              <figure className="post-media br-sm">
                <img
                  src={article.cover_image || "default-image.jpg"}
                  alt="Blog"
                  style={{ width: "100%", height: "auto" }}
                />
              </figure>
              <div className="post-details">
                <div className="post-meta">
                  <span className="post-author">Erstellt: </span>
                  <span className="post-date">
                    {new Date(article.created_at).toLocaleDateString("de-DE")}
                  </span>
                </div>

                <div>
                  {/* If your content is stored as HTML string */}
                  <div
                    className="blog-article-content"
                    style={{
                      fontSize: "14px",
                      color: "#666666",
                      lineHeight: "1.6",
                    }}
                    dangerouslySetInnerHTML={{ __html: article.html }}
                  ></div>

                  {/* If delta stored, handle delta rendering with Tiptap/Quill */}
                  {/* Placeholder for delta content */}
                  {article.delta && (
                    <pre>{JSON.stringify(article.delta, null, 2)}</pre>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </main>

    <Footer />
  </div></>
  );
}

export default BlogDetail;
